const o={rouvyApp:{rouvy:"https://account.rouvy.com/get-started"},companionApp:{rouvy:o=>`https://rouvy.com/${o}/feature/companion-app`},routeCreator:{rouvy:"https://account.rouvy.com/get-started#rouvy-route-creator-download"}};export{o as l};
//# sourceMappingURL=links-11743294.js.map
